import { render, staticRenderFns } from "./learnMaterials.vue?vue&type=template&id=88505822&scoped=true&"
import script from "./learnMaterials.vue?vue&type=script&lang=js&"
export * from "./learnMaterials.vue?vue&type=script&lang=js&"
import style0 from "./learnMaterials.vue?vue&type=style&index=0&id=88505822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88505822",
  null
  
)

export default component.exports